//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  TextField,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer';
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';
import { DataTypeSelect    } from '../DataTypeSelect/DataTypeSelect';

// === UTILS ===
import { keyframes } from 'components/utils';
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function RecordControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { id, data, is_predicate } = props;

  const { updateExpression, updatePredicate, records } = useContext( ExpressionContext );

  const [ field_name, setFieldName ] = useState( data?.name );
  const [ is_changed, setIsChanged ] = useState( false );

  let play_animation = false;

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      gridColumn: 4,
      gridRow: 1,
      // -----
      display: 'grid',
      width:'100%',
      columnGap:'0.5rem',
      gridTemplateColumns:'auto 1fr',
      gridTemplateRows:'1fr',
    },
    select_field: {
      maxWidth: '40rem',
      animation: is_changed ? `${keyframes.confirm} 1s 1` : '',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  const SELECT_FIELD = {
    sx          : _styles.select_field,
    id          : 'field-select',
    options     : records,
    value       : field_name,
    size        : 'small',
    freeSolo    : true,
    onChange    : onChange,
    onKeyDown   : onKeyDown,
    renderInput : (params) => <TextField {...params} onBlur={onBlur} label="Field" />,
    disableClearable : true,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    const name = value?.value ? value.value : value;
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { name } )
    setIsChanged( true );
  }
  
  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    setIsChanged( false );
  }
  
  //-----------------------------------------------------------------
  function onBlur( event ) {
    //-----------------------------------------------------------------
    const name = event.target.defaultValue;
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { name } )
    setIsChanged( true );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={_styles.container}>
        <DataTypeSelect id={id} type={data?.type} />
        <Autocomplete { ...SELECT_FIELD } />
      </div>
    );
  }

  //#endregion

  return display();
}
